module.exports = __webpack_public_path__ + "media/images/riders/ALAN_HATHERLY-5919b436a3535500a22958c6adebe2ae.png";